// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconPendingCommands = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 24 24' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m-.937-15.312V12c0 .313.156.605.417.781l3.75 2.5a.935.935 0 0 0 1.301-.261.934.934 0 0 0-.261-1.301L12.938 11.5V6.688A.935.935 0 0 0 12 5.75a.935.935 0 0 0-.937.938'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconPendingCommands)
const Memo = memo(ForwardRef)
export default Memo
